import { css } from 'styled-components';
import { theme } from 'modules/tetrisTheme';
export const iconButtonBase = css `
  flex-shrink: 0;

  ${({ $round }) => $round &&
    `
    border-radius: ${theme.borderRadius.circle};
  `}
`;
